export default [{
  path: '/recruit',
  children: [{
    path: 'home',
    name: '主页 ',
    meta: {
      title: '首页'
    },
    component: () => import('@/views/recruit/home.vue')
  }, {
    path: 'articleDetail',
    name: '公告详情',
    meta: {
      title: '公告详情'
    },
    component: () => import('@/views/recruit/articleDetail.vue')
  }, {
    path: 'applicationJob',
    name: '岗位投递',
    meta: {
      title: '岗位投递'
    },
    component: () => import('@/views/recruit/applicationJob.vue')
  }, {
    path: 'applicationResult',
    name: '岗位投递结果',
    meta: {
      title: '岗位投递结果'
    },
    component: () => import('@/views/recruit/applicationResult.vue')
  }, {
    path: 'queryResults',
    name: '成绩查询',
    meta: {
      title: '成绩查询'
    },
    component: () => import('@/views/recruit/queryResults.vue')
  }, {
    path: 'printTicket',
    name: '打印准考证',
    meta: {
      title: '打印准考证'
    },
    component: () => import('@/views/recruit/printTicket.vue')
  }, {
    path: 'noticeSearch',
    name: 'noticeSearch',
    meta: {
      title: '招聘公告',
      keepAlive: false, // 判断是否需要缓存
      isBack: false // 判断是否为返回操作
    },
    component: () => import('@/views/recruit/noticeSearch.vue')
  }, {
    path: 'postRecord',
    name: '投递记录',
    meta: {
      title: '投递记录'
    },
    component: () => import('@/views/recruit/postRecord.vue')
  }, 
  {
    path: 'recruitPrint',
    name: '打印应聘登记表',
    meta: {
      title: '打印应聘登记表'
    },
    component: () => import('@/views/recruit/recruitPrint.vue')
  },
  {
    path: 'postRecordInfo',
    name: '投递详情',
    meta: {
      title: '投递详情'
    },
    component: () => import('@/views/recruit/postRecordInfo.vue')
  }, {
    path: 'applicationEdit',
    name: '编辑应聘登记表',
    meta: {
      title: '编辑应聘登记表'
    },
    component: () => import('@/views/recruit/applicationEdit.vue')
  }]
}]